import { render, staticRenderFns } from "./ProductBlockVideoElement.vue?vue&type=template&id=39a61318&scoped=true&"
import script from "./ProductBlockVideoElement.vue?vue&type=script&lang=js&"
export * from "./ProductBlockVideoElement.vue?vue&type=script&lang=js&"
import style0 from "./ProductBlockVideoElement.vue?vue&type=style&index=0&id=39a61318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a61318",
  null
  
)

export default component.exports